/* eslint-disable no-template-curly-in-string */
/* eslint-disable react/no-danger */
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import {
  Container,
  ContentPageWrapper,
  HeaderProfile,
  WhatsappButton,
} from '@presentation/components';
import contactDog from '@assets/dogphone.webp';
import Karamel from './assets/karamel.webp';
import type { ThankyouPageProps } from './types';
import * as Styled from './styled';

export * from './types';

export const ThankyouPage: FC<ThankyouPageProps> = (props) => {
  const { assistanceLink, onWhatsAppClick } = props;
  const { translate } = useTranslation();
  const buttonLabel = translate('thankyou.cta.label');
  return (
    <>
      <HeaderProfile
        title={translate('thankyou.title')}
        subtitle={translate('thankyou.subtitle')}
      />
      <Container>
        <Styled.Card>
          <Styled.BackgroundWrapper>
            <Styled.BackgroundImg src={contactDog} />
          </Styled.BackgroundWrapper>
          <Styled.FormWrapper>
            <Styled.LogosWrapper>
              <Styled.TipawLogo color="dark" type="tipaw" />
              <Styled.X>x</Styled.X>
              <Styled.LogoWrapper src={Karamel} alt="karamel logo" />
            </Styled.LogosWrapper>
            <ContentPageWrapper
              dangerouslySetInnerHTML={{ __html: translate('thankyou.content') }}
            />
            <Styled.ButtonWrapped>
              <WhatsappButton
                shrink
                size="medium"
                label={buttonLabel}
                onClick={onWhatsAppClick}
                color="whatsappGreen"
              />
            </Styled.ButtonWrapped>
            <ContentPageWrapper
              dangerouslySetInnerHTML={{
                __html: translate('thankyou.assistance').replaceAll(
                  '$assistanceLink',
                  assistanceLink,
                ),
              }}
            />
          </Styled.FormWrapper>
        </Styled.Card>
      </Container>
    </>
  );
};
